import { Component, Element, Event, h, Host, Prop } from '@stencil/core';
import { v4 as uuidv4 } from 'uuid';
export class Header {
  constructor() {
    this.achromatic = false;
    this.type = 'h1';
    this.version = '4.1.9';
    this.uuid = uuidv4();
  }
  componentWillLoad() {
    // check if there is a toggle Element given via slot[name=overlay] (Mandatory)
    this.slottedHeader = this.el.querySelector('[slot="header"]');
  }
  render() {
    return (h(Host, { exportparts: "c-header, c-header-topline" },
      this.topline && (h("span", { id: this.uuid + '-topline', class: "topline", part: "c-header-topline" }, this.topline)),
      this.type === 'h1' && (h("h1", Object.assign({}, this.topline && { ['aria-labelledby']: this.uuid + '-topline' }, { part: "c-header" }),
        h("slot", null))),
      this.type === 'h2' && (h("h2", Object.assign({}, this.topline && { ['aria-labelledby']: this.uuid + '-topline' }, { part: "c-header" }),
        h("slot", null))),
      this.type === 'h3' && (h("h3", Object.assign({}, this.topline && { ['aria-labelledby']: this.uuid + '-topline' }, { part: "c-header" }),
        h("slot", null))),
      this.type === 'h4' && (h("h4", Object.assign({}, this.topline && { ['aria-labelledby']: this.uuid + '-topline' }, { part: "c-header" }),
        h("slot", null))),
      this.type === 'legend' && (h("h2", { class: "legend", exportparts: "c-header-inner", part: "c-header" },
        h("span", { part: "c-header-inner" },
          h("slot", null)))),
      this.type === 'group' && (h("h2", { class: "group", exportparts: "c-header-inner", part: "c-header" },
        h("span", { part: "c-header-inner" },
          h("slot", null))))));
  }
  static get is() { return "c-header"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["c-header.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["c-header.css"]
  }; }
  static get properties() { return {
    "achromatic": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "achromatic",
      "reflect": true,
      "defaultValue": "false"
    },
    "headline": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "headline",
      "reflect": true
    },
    "subline": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "subline",
      "reflect": true
    },
    "topline": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "topline",
      "reflect": true
    },
    "type": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "'h1' | 'h2' |'h3' | 'h4' | 'legend' | 'group'",
        "resolved": "\"group\" | \"h1\" | \"h2\" | \"h3\" | \"h4\" | \"legend\"",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "type",
      "reflect": true,
      "defaultValue": "'h1'"
    },
    "version": {
      "type": "string",
      "mutable": true,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "version",
      "reflect": true,
      "defaultValue": "'4.1.9'"
    }
  }; }
  static get events() { return [{
      "method": "close",
      "name": "close",
      "bubbles": true,
      "cancelable": true,
      "composed": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "complexType": {
        "original": "any",
        "resolved": "any",
        "references": {}
      }
    }]; }
  static get elementRef() { return "el"; }
}
